import defineComponent from 'flight';
import $ from 'static/script/libs/jquery';
import History from 'static/script/utils/history';
import fullPath from 'static/script/utils/full-path';
import openJavascriptHref from 'static/script/app/ui/open-javascript-href';

function SearchResultHeaderUI() {
    this.defaultAttrs({
        sortButtonSelector: '[data-form-select-select]',
        selectBoxSelector: '[data-form-select]',
        filterJavascriptLink: '[data-javascript-href]'
    });

    this._sortChanged = function(evt) {
        let url = $(evt.target)
            .find(':selected')
            .data('url');
        let newSearchOrder =
            $(evt.target)
                .find(':selected')
                .text() || '';
        let callbackDone = false;

        let hitCallback = function() {
            if (callbackDone === false) {
                // callback should never be ran twice (ipad issue when using hitCallback + setTimeout)
                this.trigger(document, 'ui:navigate', { href: url });
            }
            callbackDone = true;
        }.bind(this);

        this.trigger(document, 'analytics:track-event', {
            category: 'Search Filters',
            action: 'Sort order change',
            label: newSearchOrder,
            hitCallback: hitCallback
        });

        setTimeout(function() {
            hitCallback();
        }, 1000);
    };

    this._filterClick = function(evt) {
        evt.preventDefault();
        const url = $(evt.currentTarget).attr('data-javascript-href');
        openJavascriptHref(url, evt);
    };

    this.after('initialize', function() {
        this.on('change', {
            sortButtonSelector: this._sortChanged
        });
        this.on('click', {
            filterJavascriptLink: this._filterClick
        });
    });
}

export default defineComponent.component(SearchResultHeaderUI);



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/search-result/search-result-header-ui.js